








































































import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { ActionNames as ExerciseProgramActionNames } from '@/store/modules/exercise-program/keys'
import { getPatientName } from '@/utils/patients'
import { FlatPatient } from '@/store/modules/patient/getters'
import { PATIENT_NOUN } from '@/constants/app-variables'

import { UserActionContexts } from '@/constants/urls'

import MyPatientsDataTable from '@/components/patients/MyPatientsDataTable.vue'
import MyPatientsFilterFunctions from '@/components/patients/MyPatientsFilterFunctions.vue'
import PatientManagementWizard from '@/components/patients/dialogs/PatientManagementWizard.vue'
import { DetailedPatientActionNames, DetailedPatientGetterNames } from '@/store/modules/detailed-patient/keys'
import {
  allPackageDeviceTypes,
  allPatientManagementWizardDetailedPatientInformationKeys as allDetailedPatientInfoKeys,
  PatientManagementWizardDetailedPatientInformationKeys as DetailedPatientInformationKeys,
  VibePackageDeviceTypes as DeviceTypes,
} from '@/constants/patients'
import { updatePatientQuery } from '@/jsonapi/DetailedPatient'
import { FlatDetailedPatient } from '@/store/modules/detailed-patient/getters'

const filterOptions = [
  { label: 'IN PROGRESS', value: 'active' },
  { label: 'COMPLETED', value: 'completed' },
  { label: 'ALL', value: '' },
]

type ComponentData = {
  initialLoading: boolean
  searchText: string
  filter: string
  filterOptions: Array<{ label: string; value: string }>
  selectedFilter: { label: string; value: string }
  patientNoun: string
  showPatientManagementWizard: boolean
  chosenPatientForEditId: string | null
  patientManagementWizardActionContext: UserActionContexts.New | UserActionContexts.Edit
  showRemovePackageFromPatientDialog: boolean
  isSendingRemovePackageFromPatientRequest: boolean
  errorMessage: ''
}

export default Vue.extend({
  name: 'PatientIndex',
  components: {
    MyPatientsFilterFunctions,
    MyPatientsDataTable,
    PatientManagementWizard,
  },
  data(): ComponentData {
    return {
      errorMessage: '', // TODO ERROR MESSAGE
      initialLoading: true,
      searchText: '',
      filter: 'current',
      filterOptions,
      selectedFilter: filterOptions[0],
      patientNoun: PATIENT_NOUN,
      showPatientManagementWizard: false,
      chosenPatientForEditId: null,
      patientManagementWizardActionContext: UserActionContexts.New,
      showRemovePackageFromPatientDialog: false,
      isSendingRemovePackageFromPatientRequest: false,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.patients]),

    filteredPatients(): FlatPatient[] {
      const lowerCasedSearchText = this.searchText.toLowerCase()
      return this[PatientGetterNames.patients]
        .filter(patient => patient.status.includes(this.selectedFilter.value))
        .filter(patient => {
          const patientText = `${patient.phoneNumber} ${getPatientName(patient)}`.toLowerCase()
          return patientText.includes(lowerCasedSearchText)
        })
    },
    currentPatient() {
      return this.chosenPatientForEdit
    },
    vibeId() {
      let p = this.currentPatient
      let vp = p && p.vibePackage
      return this.currentPatient && this.currentPatient.vibePackage && this.currentPatient.vibePackage.vibeId
    },
    chosenPatientForEdit() {
      // return this[DetailedPatientGetterNames.patients].find(patient => patient.id === this.chosenPatientForEditId)
      return this[PatientGetterNames.patients].find(patient => patient.id === this.chosenPatientForEditId)
    },
    chosenPatientForEditFullName() {
      if (this.chosenPatientForEditId) {
        return getPatientName(this.chosenPatientForEdit)
      }
      return ''
    },
  },
  async mounted(): Promise<void> {
    await this[PatientActionNames.getPatients]()
    await this[ExerciseProgramActionNames.getExercisePrograms]()
    this.initialLoading = false
  },
  methods: {
    openPatientManagementWizardForNew() {
      this.patientManagementWizardActionContext = UserActionContexts.New
      this.showPatientManagementWizard = true
    },
    closePatientManagementWizard() {
      this.showPatientManagementWizard = false
      // reset so if this patient is opened next, it is re-loaded
      this.chosenPatientForEditId = null
    },
    openPatientManagementWizardForEdit(payload) {
      this.chosenPatientForEditId = payload
      this.patientManagementWizardActionContext = UserActionContexts.Edit
      this.showPatientManagementWizard = true
    },
    closeRemovePackageFromPatientDialog() {
      this.showRemovePackageFromPatientDialog = false
    },
    openRemovePackageFromPatientDialog(payload) {
      this.chosenPatientForEditId = payload
      this.showRemovePackageFromPatientDialog = true
    },
    confirmDeletePackageFromPatientAction() {
      console.info('this function will handle removing a package from a patient once the API is implemented')
      this.isSendingRemovePackageFromPatientRequest = true

      let patientForUpload = {
        ...this.currentPatient,
      }
      patientForUpload.removePackage = true

      this.errorMessage = null
      this.initialLoading = true
      updatePatientQuery(patientForUpload as FlatDetailedPatient)
        .then(() => {})
        .catch((error: any) => {
          this.errorMessage = 'Failed to remove. Please try again later'
        })
        .finally(() => {
          this.isSendingRemovePackageFromPatientRequest = false
          this.showRemovePackageFromPatientDialog = false
          this.initialLoading = false
          this.chosenPatientForEditId = null
        })
    },
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.exerciseProgram, [ExerciseProgramActionNames.getExercisePrograms]),
  },
})
